import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useAppointmentAnalyses from 'hooks/useAppointmentAnalyses';
import { appointmentAnalysesSelectors } from "features/appointmentAnalyses";

const AppointmentAnalysesList = () => {
  const { getAppointmentAnalyses } = useAppointmentAnalyses();
  const { data, pagination } = useCustomSelector(appointmentAnalysesSelectors.getAppointmentAnalysesData);
  const fetching = useCustomSelector(appointmentAnalysesSelectors.appointmentAnalysesIsFetching);

  return (
    <BaseAnalysesList
      fetchData={getAppointmentAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <AppointmentAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);